import React, { Component } from 'react';
import { Icon, message } from 'antd';
import i18n from "../../../../constants/initLng";

import PasswordInput from './../../common/component/PasswordInput';
import { HeaderComponent } from './../../common/component/Index';
import {strongPassword} from './../../../../helpers/validation';

import './style.less';

export default class ChangePassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
            validate: {},
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps && nextProps.values && (
            nextProps.values.current !== this.state.currentPassword
            || nextProps.values.new !== this.state.newPassword
            || nextProps.values.confirm !== this.state.confirmPassword
        )) {
            this.setState({ currentPassword: nextProps.values.current, newPassword: nextProps.values.new, confirmPassword: nextProps.values.confirm })
        }
    }

    onSave = (event) => {
        if(event) event.preventDefault();
        if (this.props.onSave && this.validateInputs()) {
            return this.props.onSave({
                current: this.state.currentPassword,
                new: this.state.newPassword,
                confirm: this.state.confirmPassword,
            });
        }
    }

    onChangePassword = (type) => {
        return (event) => {
            const pass = event.target.value;
            if(type) this.setState({ [type]: pass || '' })
        }
    }

    onEnter = () => this.onSave();

    handleKeyDown = (event) => event.key === 'Enter' && this.onEnter()

    render() {
        const { currentPassword, newPassword, confirmPassword, validate } = this.state;
        const { loading } = this.props;
        return (
            <section className="change-password">
                <div className="change-password-box">
                    <div>
                        <div className="text-center password-header">
                            <Icon type={'lock'} style={{ fontSize: '24px', marginRight: 10 }} />
                            <h2>{i18n.t('item.user.changePassword')}</h2>
                        </div>
                        <form className="form-horizontal form-material" action="" method={`POST`} onSubmit={this.onSave}>
                            <fieldset disabled={loading}>
                                <div className="form-group">
                                    <PasswordInput error={validate.currentPassword} value={currentPassword} onChange={this.onChangePassword('currentPassword')} disabled={loading} placeholder={i18n.t('item.user.oldPassword')} autoFocus/>
                                </div>
                                <div className="form-group">
                                    <PasswordInput error={validate.newPassword} value={newPassword} onChange={this.onChangePassword('newPassword')} disabled={loading} placeholder={i18n.t('item.user.newPassword')} />
                                </div>
                                <div className="form-group">
                                    <PasswordInput error={validate.confirmPassword} value={confirmPassword}
                                    onChange={this.onChangePassword('confirmPassword')} disabled={loading} placeholder={i18n.t('item.user.confirmPassword')}
                                    onKeyDown={this.handleKeyDown}/>
                                </div>
                                <button type="submit" className="btn btn-primary block full-width m-b" disabled={loading} type="submit">{i18n.t('action.update')} {loading && <Icon type="sync" spin />}</button>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </section>
        );
    }

    validateInputs() {
        const { currentPassword, newPassword, confirmPassword } = this.state;
        const validate = {};
        if (!currentPassword || !currentPassword.length) {
            validate.currentPassword = i18n.t('validation.currentPasswordRequired');
        }
        if (!newPassword || !newPassword.length) {
            validate.newPassword = i18n.t('validation.newPasswordRequired');
        }
        if (newPassword && strongPassword(newPassword)) {
            validate.newPassword = i18n.t('validation.password');
        }
        if (!confirmPassword || !confirmPassword.length) {
            validate.confirmPassword = i18n.t('validation.confirmPasswordRequired');
        }
        if (newPassword && confirmPassword && newPassword !== confirmPassword) {
            validate.confirmPassword = i18n.t('validation.comparePassword');
        }
        const isValid = !Object.keys(validate).length;
        if(!isValid){
            message.error(i18n.t('validation.checkForm'));
        }
        this.setState({validate})
        return isValid;
    }
}

